/*
 *
 * BookingDetailActionsPopUp
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 19-Mar-2025
 */

import BookingDetailActionsPopUp from './BookingDetailActionsPopUpContainer'

export default BookingDetailActionsPopUp
